const faqs = [
  {
    q: '68影院真的可以免费在线观看吗？需要注册吗？',
    a: '是的，68影院所有电影均为高清免费在线观看，无需注册、无需登录即可直接播放。我们致力于降低观影门槛，让你打开网站就能立刻享受影院级观影体验。'
  },
  {
    q: '电影画质怎么样？播放会卡顿缓冲吗？',
    a: '全站提供1080P及以上高清片源，采用智能自适应码率技术，根据你的网络状况自动匹配最佳画质。大部分影片支持在线观看不缓冲，加载速度快，播放流畅稳定。'
  },
  {
    q: '热门电影排行榜是如何排序的？更新频率怎样？',
    a: '排行榜综合全网热度、播放量、用户口碑等多维度数据，通过智能算法实时计算排序，每日自动刷新。你看到的热门电影排名始终反映当前最受欢迎的内容。'
  },
  {
    q: '片库覆盖哪些类型？能找到老电影吗？',
    a: '电影大全片库涵盖动作、喜剧、悬疑、科幻、爱情、恐怖、动画、纪录片等全类型，覆盖国内外热门电影。经典老片与最新电影同步收录，片库总量超50,000部且持续增长中。'
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            快速了解68影院，解答你的观影疑问
          </p>
        </div>
        <div className="max-w-3xl mx-auto divide-y divide-background-200/60">
          {faqs.map((faq, i) => (
            <div key={i} className="py-5 md:py-6">
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2">
                {faq.q}
              </h3>
              <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}